




























































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { MobileCoupon } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { form, autoclose, shopBase } from "@/mixins";
import dayjs from "dayjs";

const db = firebaseProject.firestore();
const coupon = new Collection(
  db.collection("mobileCoupon") as firestore.CollectionReference<MobileCoupon>
);

export default shopBase.extend(Vue).extend({
  name: "MobileOrderCouponList",
  mixins: [],
  data() {
    return {
      authentication,
      transitionName: "",
      parPage: 10,
      currentPage: 1
    };
  },
  computed: {
    coupons(): List<MobileCoupon> {
      return coupon.query({
        filter: {
          shopId: { $eq: this.shopId },
          tenantId: { $eq: null }
        },
        orderBy: [
          {
            field: "createTime",
            order: "desc"
          }
        ]
      });
    },
    listItem(): DocDataRef<MobileCoupon>[] | [] {
      const current = this.currentPage * this.parPage;
      const start = current - this.parPage;
      return this.coupons?.items
        ? this.coupons.items.slice(start, current)
        : [];
    },
    getPageCount(): number {
      return this.coupons?.items
        ? Math.ceil(this.coupons.items.length / this.parPage)
        : 0;
    },
    total(): number {
      return this.coupons.items?.length || 0;
    },
    pageMax(): number {
      const count = this.currentPage * this.parPage;
      const total = this.total || 0;
      return total < count ? total : count;
    }
  },
  methods: {
    clickPaginate(pageNum: number) {
      this.currentPage = Number(pageNum);
    },
    nowAvailable(item: DocDataRef<MobileCoupon>) {
      const now = Date.now();
      return (
        item.data?.availableFrom ||
        (0 <= now && item.data?.availableTo) ||
        0 >= now
      );
    },
    availableStatus(item: DocDataRef<MobileCoupon>) {
      const now = Date.now();
      if (
        !item.data?.availableFrom ||
        dayjs(item.data?.availableFrom).valueOf() > now
      ) {
        // 配信前
        return 1;
      } else if (
        dayjs(item.data?.availableFrom).valueOf() <= now &&
        (!item.data?.availableTo ||
          dayjs(item.data?.availableTo).valueOf() >= now)
      ) {
        // 配信中
        return 2;
      } else {
        // 配信終了
        return 3;
      }
    },
    availableStatusText(item: DocDataRef<MobileCoupon>) {
      if (this.availableStatus(item) == 1) {
        // 配信前
        return "配信前";
      } else if (this.availableStatus(item) == 2) {
        // 配信中
        return "配信中";
      } else if (this.availableStatus(item) == 3) {
        // 配信終了
        return "配信終了";
      }
    }
  },
  watch: {}
});
